var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"locale-changer rtl:mb-2.5 rtl:md:mb-3 mt-1",style:({ fontFamily: _vm.fontUsed })},[_c('button',{staticClass:"text-secondary text-lg md:text-3xl relative font-bold",class:{ 'top-1': _vm.$i18n.locale === 'ar' },on:{"click":_vm.changeLocale}},[_vm._v(" "+_vm._s(_vm.languages[_vm.$i18n.locale])+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }